import type { ServicesContext } from '@takeshape/schema';
import { getServiceProvider } from '@takeshape/service-providers';

export const SUPPORTED_AI_PROVIDERS = [
  'openai',
  'anthropic',
  'azureOpenai',
  'googleVertex',
  'groq',
  'portkey'
] as const;

export type SupportedAiProvider = (typeof SUPPORTED_AI_PROVIDERS)[number];

export function isSupportedAIProvider(str: string): str is SupportedAiProvider {
  return (SUPPORTED_AI_PROVIDERS as readonly string[]).includes(str);
}

export type AIServiceDefaults = {
  service: string;
  generateModel?: string;
  embeddingModel?: string;
};

export function getDefaultAIService({ services = {} }: ServicesContext): AIServiceDefaults | undefined {
  for (const service of Object.values(services)) {
    const provider = getServiceProvider(service.provider);
    if (provider?.getAiModels) {
      const models = provider.getAiModels();
      return {
        service: service.id,
        generateModel: models.generate[0],
        embeddingModel: models.embedding[0]
      };
    }
  }
}
